module.exports = __webpack_public_path__ + "img/northmacedonia.9ca761d4.png";